/*
 * Alt-text variant photo filter.
 * On color/variant change, shows only the product images whose ALT TEXT matches a
 * selected option value (e.g. alt "Black" when Black is chosen) and hides the rest,
 * then refreshes the gallery dots. If no image matches the selection, all images show
 * (graceful fallback). Convention: tag each product image's alt text with its color.
 */
(function () {
  if (window.__nuisetteVariantMediaFilter) return;
  window.__nuisetteVariantMediaFilter = true;

  function norm(s) {
    return (s || '').trim().toLowerCase();
  }

  function selectedValues() {
    var vs = document.querySelector('variant-selects');
    if (!vs) return [];
    var vals = [];
    vs.querySelectorAll('select').forEach(function (s) {
      vals.push(s.value);
    });
    vs.querySelectorAll('input[type="radio"]:checked').forEach(function (i) {
      vals.push(i.value);
    });
    return vals.map(norm).filter(Boolean);
  }

  function altMatches(alt, vals) {
    var a = norm(alt);
    if (!a) return false;
    var tokens = a.split(/[\s\-_/|,.]+/);
    return vals.some(function (v) {
      return a === v || a.indexOf(v + ' ') === 0 || a.indexOf(v + '-') === 0 || tokens.indexOf(v) !== -1;
    });
  }

  function apply() {
    var vals = selectedValues();
    if (!vals.length) return;

    document.querySelectorAll('.product__media-wrapper').forEach(function (wrap) {
      var items = Array.prototype.slice.call(wrap.querySelectorAll('.product__media-item'));
      if (!items.length) return;

      var matches = items.filter(function (li) {
        var img = li.querySelector('img');
        return img && altMatches(img.getAttribute('alt'), vals);
      });
      // Only filter when the selection actually has tagged images; otherwise show all.
      var useFilter = matches.length > 0;
      var visible = {};

      items.forEach(function (li) {
        var show = !useFilter || matches.indexOf(li) !== -1;
        li.hidden = !show;
        li.classList.toggle('is-media-hidden', !show);
        if (show && li.dataset.mediaId) visible[li.dataset.mediaId] = true;
      });

      // Thumbnails reference their media via data-target (= the slide's data-media-id).
      wrap.querySelectorAll('.thumbnail-list__item').forEach(function (t) {
        var show = !useFilter || !!visible[t.dataset.target];
        t.hidden = !show;
        t.classList.toggle('is-media-hidden', !show);
      });

      // Promote the first visible image to the main viewer. On desktop the gallery shows
      // only the active item large, so it goes blank if the active one was just hidden.
      var first = items.filter(function (li) { return !li.hidden; })[0];
      var gallery = wrap.querySelector('media-gallery');
      if (useFilter && first && first.dataset.mediaId && gallery && typeof gallery.setActiveMedia === 'function') {
        var activeNow = wrap.querySelector('.product__media-item.is-active');
        var activeHidden = !activeNow || activeNow.hidden || activeNow.classList.contains('is-media-hidden');
        if (activeHidden) {
          try { gallery.setActiveMedia(first.dataset.mediaId, false); } catch (e) {}
        }
      }

      // Snap the mobile slider back to the first visible image.
      var track = wrap.querySelector('.product__media-list');
      if (track) {
        try {
          track.scrollTo({ left: first ? first.offsetLeft : 0 });
        } catch (e) {
          track.scrollLeft = 0;
        }
      }
    });

    // Tell the gallery dots to rebuild for the now-visible set.
    document.dispatchEvent(new CustomEvent('product-gallery:refresh'));
  }

  // Run after the theme's own variant-change handlers settle. Uses setTimeout rather
  // than requestAnimationFrame (rAF is frozen in background/hidden tabs), and re-applies
  // once more to win any race with the theme's async section re-render.
  function schedule() {
    setTimeout(apply, 60);
    setTimeout(apply, 350);
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, schedule);
  }
  document.addEventListener('change', function (e) {
    if (e.target && e.target.closest && e.target.closest('variant-selects')) schedule();
  });

  // No initial filter: ALL media show by default. The dropdown defaulting to a color is
  // NOT a user selection — filtering only begins once the shopper actually changes color.
})();
